import { h } from 'preact';

const MenuBanner = ({ image, heading, cta, url }) => {
  if (!image) {
    return null;
  }
  const Wrapper = url ? 'a' : 'div';

  return (
    <Wrapper
      href={url}
      className="relative text-white w-full tablet:w-1/4 lg:max-w-[343px]"
    >
      <img src={image} className="w-full" />
      <div className="absolute py-24 px-16 md:px-32 tablet:p-24 bottom-0 left-0">
        {!!heading && <div className="display-3 mb-8">{heading}</div>}
        {!!(cta && url) && (
          <a
            href={url}
            className="cta-secondary pb-4 border-b hover:border-transparent"
          >
            {cta}
          </a>
        )}
      </div>
    </Wrapper>
  );
};

export default MenuBanner;
